/**
 * An easily mockable wrapper over Window.localStorage
 */
(function(){
  angular.module('core').factory('edxLocalStorageService', [localStorageServiceFactory]);

  function localStorageServiceFactory() {

    function length() {
      return localStorage.length;
    }

    function key(index) {
      return localStorage.key(index);
    }

    function getItem(key) {
      return localStorage.getItem(key);
    }

    function setItem(key, value) {
      localStorage.setItem(key, value);
    }

    function removeItem(key) {
      localStorage.removeItem(key);
    }

    function clear() {
      localStorage.clear();
    }

    return {
      length: length,
      key: key,
      getItem: getItem,
      setItem: setItem,
      removeItem: removeItem,
      clear: clear
    };
  }
})();